export const HOCHLADBARE_DOKUMENTE: readonly string[] = [
  "E-Mail-Kontakt Jobcenter",
  "Nachweise",
  "Nichtantrittsbogen F5.2",
  "E-Mail ans Jobcenter (Nichtantritt)",
  "Häusliche Aktivierung",
  "Start-Info-Mail ans Jobcenter",
  "Arbeitsunfähigkeitsbescheinigung",
  "Fehlzeitenbriefe",
]
